// Adapted from the standard Create React App PWA template's registration
// helper. Only registers in production builds — during `npm start` the
// service worker would otherwise cache dev bundles and cause confusing
// "why isn't my change showing up" bugs.
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  const publicUrl = new URL(process.env.PUBLIC_URL || '/', window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    if (isLocalhost) {
      // Still register on localhost (useful for testing the SW itself
      // against a production build served locally), but validate it
      // actually exists first so a missing file fails quietly.
      fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
        .then((response) => {
          const contentType = response.headers.get('content-type');
          if (response.status === 404 || (contentType && contentType.indexOf('javascript') === -1)) {
            navigator.serviceWorker.ready.then((registration) => registration.unregister());
          } else {
            navigator.serviceWorker.register(swUrl).catch(console.error);
          }
        })
        .catch(() => {
          console.log('No internet connection found. App running in offline-unaware mode.');
        });
    } else {
      navigator.serviceWorker.register(swUrl).catch(console.error);
    }
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => console.error(error.message));
}
